
import { defineComponent } from "vue";
import DateUtils from "@/utils/DateUtils";
import stateStore from "@/utils/store";

export default defineComponent({
    name: "FormatDateRow",
    props: {
        value: {
            type: String,
            required: true,
        },
        mode: {
            type: String,
            required: true,
        },
    },
    setup() {
        const stateStoreInstance = stateStore;
        return {
            stateStoreInstance,
        };
    },


    methods: {
        formatDate(date: any): string {
            return DateUtils.formatDate(date);
        },
        formatDateTime(date: any): string {
            return DateUtils.formatDateTime(date);
        },
    },
});
